import React, { useEffect, useState } from 'react';
// import View from '../../../modules/View';
import apiService from 'apiService';
import View from 'view/portal/pages/services-page/modules/View';
import { toast } from 'view/component/Alert';

const FormPersyaratanPenyuluhan = ({
  existingPersyaratan,
  nextStep,
  setStep,
  setData,
  formIRT,
  PIRTTrans = {},
  onAfterPost,
  isShow,
  idPendaftaran,
  ini,
  idJadwal,
  ...rest
}) => {
  const [persyaratan, setPersyaratan] = useState('');
  useEffect(() => {
    if (formIRT) {
      // setParam((state) => ({ ...state, pirt_form_id: formIRT.id }));
      let dat = { type: "penyuluhan", pirt_form_id: formIRT.id };
      createPirt(dat);
      // console.log(dat)
    }
  }, [formIRT]);
  const submitJadwal = async (pirt) => {
    const response = await apiService.post('pirt/trx_jadwal/set', {
      id: pirt.id,
      ref_jadwal_id: idJadwal,
    });
    if (response.code === 200) {
      setData(data => ({ ...data, PIRTTrans: response.data }))
      toast({ status: 'success', text: 'data berhasil disimpan' })
    } else {
      toast({ status: 'error', text: 'jadwal sudah penuh' })
    }
  };
  const createPirt = async (dat) => {
    const result = await apiService.post("/pirt/pirt_trans/create", dat);
    if (result.code === 200) {
      // submitJadwal(result.data)
      setData((data) => ({ ...data, PIRTTrans: result.data }));
    } else {
      alert(result?.data.data);
      setStep(1);
    }
  };
  const getPersyaratan = async () => {
    try {
      const responses = await apiService.get(
        '/pirt/persyaratan/read/penyuluhan'
      );
      if (responses) {
        setPersyaratan(responses.data);
      }
    } catch (error) {
      setPersyaratan([]);
    }
  };

  useEffect(() => {
    if (!existingPersyaratan) getPersyaratan();
    else setPersyaratan(existingPersyaratan);
  }, [isShow]);

  if (!isShow) return '';
  return (
    <>
      <View
        data={persyaratan || []}
        idPendaftaran={idPendaftaran}
        handleSubmit={() => nextStep()}
        paramMapper={(data, file) => ({
          pirt_trans_id: PIRTTrans.id,
          pirt_ref_persyaratan_id: data.id,
          upload: file,
        })}
        url='/pirt/trx_persyaratan/create'
      />
    </>
  );
};

export default FormPersyaratanPenyuluhan;
